module.exports = __webpack_public_path__ + "img/icon-cart.6c80a1b8.svg";